import o from "./indexTable.ce.vue2.js";
import r from "./indexTable.ce.vue3.js";
import t from "../../_virtual/_plugin-vue_export-helper.js";
const e = /* @__PURE__ */ t(o, [["styles", [r]]]);
export {
  e as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/components/approval-table/indexTable.ce.vue.js
// module id = 1172
// module chunks = 41